import { render } from "./ModalUpdateFile.vue?vue&type=template&id=4f939e60"
import script from "./ModalUpdateFile.vue?vue&type=script&lang=js"
export * from "./ModalUpdateFile.vue?vue&type=script&lang=js"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__